import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import process from 'process';
window.process = process;
import App from './App';

import axios from 'axios';
 
// ── Auth interceptor — reads from sessionStorage (per-tab) ────────
axios.interceptors.request.use(config => {
  const token = sessionStorage.getItem('platform_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
 
// ── Auto-logout on 401 — only clears THIS tab's session ──────────
// Skip redirect for the login endpoint itself (wrong-password returns 401)
axios.interceptors.response.use(
  response => response,
  error => {
    const isLoginCall = error.config?.url?.includes('/auth/login');
    if (error.response?.status === 401 && !isLoginCall) {
      sessionStorage.removeItem('platform_token');
      sessionStorage.removeItem('platform_user');
      sessionStorage.removeItem('isLoggedIn');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);
 

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
